import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
import { FontModel } from '@leverege/ui-style-elements';
import { ModelFactory } from '@leverege/ui-plugin';
const TYPE = 'aggregation.geoDistance.Text';
const DISPLAY_NAME = 'Text';
const resultType = 'geoDistance';
function create() {
  const FormatterModel = ModelFactory.get('attr.formatter.geoPoint');
  return {
    id: v4(),
    type: TYPE,
    displayName: DISPLAY_NAME,
    header: {
      label: {
        name: null,
        visible: true,
        color: null,
        font: FontModel.create()
      },
      subLabel: {
        formatter: FormatterModel && FormatterModel.create(),
        visible: true,
        color: null,
        font: FontModel.create()
      }
    },
    value: {
      label: {
        font: FontModel.create(),
        visible: true,
        color: null,
        trueValue: 'True',
        falseValue: 'False'
      },
      text: {
        font: FontModel.create(),
        visible: true,
        color: null
      }
    },
    variant: null
  };
}
export default {
  create,
  TYPE,
  DISPLAY_NAME,
  resultType,
  getDisplayName: ModelUtil.createGetValue('displayName'),
  ...ModelUtil.createAllValue('header/label/name', 'headerLabel'),
  ...ModelUtil.createAllValue('header/label/visible', 'headerLabelVisible'),
  ...ModelUtil.createAllValue('header/label/color', 'headerLabelColor'),
  ...ModelUtil.createAllValue('header/label/font', 'headerLabelFont'),
  ...ModelUtil.createAllValue('header/subLabel/formatter', 'headerSubLabelFormatter'),
  ...ModelUtil.createAllValue('header/subLabel/visible', 'headerSubLabelVisible'),
  ...ModelUtil.createAllValue('header/subLabel/color', 'headerSubLabelColor'),
  ...ModelUtil.createAllValue('header/subLabel/font', 'headerSubLabelFont'),
  ...ModelUtil.createAllValue('header/subLabel/visible', 'headerSubLabelVisible'),
  ...ModelUtil.createAllValue('value/label/font', 'valueLabelFont'),
  ...ModelUtil.createAllValue('value/label/visible', 'valueLabelVisible'),
  ...ModelUtil.createAllValue('value/label/color', 'valueLabelColor'),
  ...ModelUtil.createAllValue('value/text/font', 'valueTextFont'),
  ...ModelUtil.createAllValue('value/text/visible', 'valueTextVisible'),
  ...ModelUtil.createAllValue('value/text/color', 'valueTextColor'),
  ...ModelUtil.createAllValue('value/label/trueValue', 'trueValue'),
  ...ModelUtil.createAllValue('value/label/falseValue', 'falseValue'),
  ...ModelUtil.createAllValue('variant', 'variant')
};